import type { ResolvedBranding } from '@command-center/ui-system';
import { adminConfig } from './config';

export type { ResolvedBranding };

/**
 * Returns the branding shape the AppShell/Sidebar consume. Falls back to
 * sensible Cascade defaults if the config is missing optional fields.
 */
export function getBranding(): ResolvedBranding {
  const branding = adminConfig.branding;
  return {
    name: branding.name || 'Cascade Command Center',
    logoSrc: branding.logo,
    iconSrc: branding.iconSrc,
    shortLabel: adminConfig.clientName || 'Cascade',
    iconText: branding.icon || 'CS',
    colors: branding.colors,
  };
}
